import React from "react";
import { cn } from "../../lib/cn";

export function Pagination({
  current = 1,
  pageSize = 10,
  total = 0,
  onChange,
  showTotal,
  className,
  style,
  pageSizeOptions,
  showSizeChanger,
  onShowSizeChange,
}) {
  const pages = Math.max(1, Math.ceil(total / pageSize));

  function go(page) {
    const p = Math.min(Math.max(1, page), pages);
    onChange?.(p, pageSize);
  }

  const items = [];
  const windowStart = Math.max(1, Math.min(current - 2, pages - 4));
  const windowEnd = Math.min(pages, windowStart + 4);
  for (let i = windowStart; i <= windowEnd; i++) {
    items.push(i);
  }

  return (
    <div
      style={style}
      className={cn(
        "flex flex-wrap items-center justify-between gap-3 text-sm text-slate-700",
        className
      )}
    >
      {showTotal ? (
        <span className="text-slate-600">
          {showTotal(total, [Math.min(total, (current - 1) * pageSize + 1), Math.min(current * pageSize, total)])}
        </span>
      ) : (
        <span />
      )}
      <div className="flex flex-wrap items-center gap-2">
        {showSizeChanger && pageSizeOptions?.length ? (
          <select
            className="rounded-lg border border-slate-200 bg-white px-2 py-1 text-sm"
            value={pageSize}
            onChange={(e) => {
              const next = Number(e.target.value);
              onShowSizeChange?.(next);
              onChange?.(1, next);
            }}
          >
            {pageSizeOptions.map((sz) => (
              <option key={sz} value={sz}>
                {sz}/page
              </option>
            ))}
          </select>
        ) : null}
        <nav className="flex items-center gap-1">
          <button
            type="button"
            className="rounded-lg border border-slate-200 px-2 py-1 disabled:opacity-40"
            disabled={current <= 1}
            onClick={() => go(current - 1)}
          >
            Prev
          </button>
          {items.map((p) => (
            <button
              key={p}
              type="button"
              onClick={() => go(p)}
              className={cn(
                "min-w-[34px] rounded-lg border px-2 py-1",
                p === current
                  ? "border-brand bg-brand-surface font-semibold text-brand"
                  : "border-slate-200 hover:bg-slate-50"
              )}
            >
              {p}
            </button>
          ))}
          <button
            type="button"
            className="rounded-lg border border-slate-200 px-2 py-1 disabled:opacity-40"
            disabled={current >= pages}
            onClick={() => go(current + 1)}
          >
            Next
          </button>
        </nav>
      </div>
    </div>
  );
}
